import axios from 'axios';
import {backendHost} from '../../config';

export const postOperatorsBlock = (params) => {
    return axios.post(`${backendHost}/api/partners/admin/operators/block`, params);
};